module.exports = __webpack_public_path__ + "static/media/naomi-woods.cb335c43.jpg";